import type { ReactNode } from "react";
import { Text } from "@/components/Text";

/**
 * Shared empty state for Build list/detail screens: centered icon, message,
 * and an optional call to action. The design system doesn't ship an
 * EmptyState yet — this is the app-level candidate for it (see
 * docs/design/web/WEB_BUILD_PATTERN_PLAN.md, phase 0).
 */
export function EmptyState({
  icon,
  title,
  body,
  action,
}: Readonly<{ icon?: ReactNode; title: string; body?: string; action?: ReactNode }>) {
  return (
    <div className="flex flex-col items-center gap-3 py-16 text-center">
      {icon && (
        <span aria-hidden className="text-content-tertiary">
          {icon}
        </span>
      )}
      <Text variant="h3">{title}</Text>
      {body && (
        <Text variant="body-sm" tone="secondary" className="max-w-md">
          {body}
        </Text>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
